// @ts-nocheck

import React, { useEffect, useRef, useState } from 'react';
import cn from 'classnames';
import { HeaderS } from '@shared/ui/header';
import { Banner } from '@features/phone-subscription';
import { isRTL, setTheme } from '@shared/utils/general';
import { APP_THEMES } from '@shared/config/constants/app';
import { Container } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import localStyles from '../styles/DCBUnsubscribeOTP.module.css';
import styles from '@features/otp-verification/styles/PinFormStyles.module.css';
import { useAtomValue } from 'jotai';
import { getUnsubLanguageConfig } from '@features/dcb-unsubscribe-country';
import { Helpers } from '@shared/utils/Helpers';

import axios from 'axios';
import Config from '@shared/config/constants/config-main';
import { unsubBannerConfig } from '@shared/config/constants/Banners';
import { languageAtom, subscriptionAtom } from '@shared/store/slice-atoms';

const DCBUnsubscribeOTP = () => {
  const { t } = useTranslation();

  const [loading, setLoading] = useState(false);
  const [pin, setPin] = useState('');
  const [error, setError] = useState('');

  const [successText, setSuccessText] = useState('');

  const formStartRef = useRef(null);
  const howItWorksRef = useRef(null);

  const subscription = useAtomValue(subscriptionAtom);
  const language = useAtomValue(languageAtom);
  const unsubscribeData = subscription.unsubscribeData;
  const languageConfig = getUnsubLanguageConfig(
    String(unsubscribeData?.country || Helpers.getUrlParameter('country') || 'ly')
  );

  useEffect(() => {
    setTheme(APP_THEMES.WHITE);
  }, []);

  const handleSubmit = async () => {
    setLoading(true);

    try {
      const sessionId = unsubscribeData?.sessionId;

      const body = {
        sessionId,
        lang: language.locale || 'en',
        otp: pin,
        forceIgnoreVuz: true,
        forceIgnoreAggregator: true,
      };

      const res = await axios.post(`${Config.API_URL}/mobile/unsubscribe/otp`, body);

      if (res.data?.statusCode !== 200) {
        setError(res.data?.data?.message || t('something_went_wrong'));
        setLoading(false);
        return;
      }

      setPin('');
      setSuccessText(res.data?.data?.message || t('unsub_success_text'));

      setTimeout(() => {
        window.location = 'https://vuz.com';
      }, 2000);
    } catch {
      setError(t('something_went_wrong'));
    } finally {
      setLoading(false);
    }
  };

  const handlePinChange = (e) => {
    setError('');

    setPin(e.target.value);
  };

  const isRTLDirection = isRTL(language.direction);
  const otpDigitsCount = unsubscribeData?.otpDigitsCount || 4;
  const isButtonDisabled = Boolean(
    error || successText || loading || pin.length !== otpDigitsCount
  );

  return (
    <article className="landing-article">
      <HeaderS
        formStartRef={formStartRef}
        howItWorksRef={howItWorksRef}
        languageConfig={languageConfig}
        isCC
        isUnsubPage
      />
      <Banner bannerConfig={unsubBannerConfig} />

      <Container className="container-sm">
        <section className="landing-section-4">
          <div dir="rtl">
            <label
              style={{ textAlign: isRTLDirection ? 'right' : 'left' }}
              className="vuz-label-1 verification-label"
            >
              {t('verification')}
            </label>
          </div>
          <div>
            <p style={{ textAlign: isRTLDirection ? 'right' : 'left' }}>{t('enter_pin')}</p>
          </div>

          <input
            className={styles.otp_input_unsub}
            maxLength={otpDigitsCount}
            minLength={otpDigitsCount}
            value={pin}
            onChange={handlePinChange}
          />

          {error && !successText ? <p className={localStyles.errorText}>{error}</p> : null}
          {successText ? <p className={localStyles.successUnsubText}>{successText}</p> : null}

          <div className={styles.otp_submit_container}>
            <button
              className={cn(
                'vuz-btn-1',
                'large',
                'lh-08',
                'sub-btn-fix2',
                localStyles.cursorPointer
              )}
              disabled={isButtonDisabled}
              onClick={handleSubmit}
            >
              {t('ubsub_button_title')}
            </button>

            <p>{t('unsub_disclamer_text')}</p>
          </div>
        </section>
      </Container>
    </article>
  );
};

export { DCBUnsubscribeOTP };
